<template>
  <div class="container">
    <h1 class="t-c">Page Not Being Used Yet</h1>
  </div>
</template>
<script>
export default {
  name: 'Publisher',
};
</script>



// WEBPACK FOOTER //
// app/src/pages/Publishers.vue